// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"styles_contentWrapper__26hxa","sectionContainer":"styles_sectionContainer__Gede9","sideBySideWrapper":"styles_sideBySideWrapper__1ti1i"};